/* eslint-disable */
export default {
  meetingTitle: 'Besprechung von {extensionName}',
} as const;

// @key: @#@"meetingTitle"@#@ @source: @#@"{extensionName}'s Meeting"@#@
